export const rules = {
  office: [{ required: true, message: '输入职位名称', trigger: 'blur' }]
}
